import PoolShare from './create_share'
import { connect } from 'react-redux'
import {
  getCampaignSelector,
  getLastCreatedCampaignSelector,
} from 'redux/selectors/campaign'
import { campaignUrlWithMeDomain } from 'lib/campaign_url'
import { fromVeniceSelector } from 'redux/selectors/venice'

const mapStateToProps = (state, props) => {
  const lastCreatedCampaign = getLastCreatedCampaignSelector(state)
  const campaign = lastCreatedCampaign || getCampaignSelector(state, props)
  const fromVenice = fromVeniceSelector()(state)

  return {
    campaignId: campaign.id,
    poolUrl: campaignUrlWithMeDomain(campaign.id, campaign.campaign_type),
    secondaryPoolButton: fromVenice,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PoolShare)
